<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "heart-check" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 18 18'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M6.75 8.25L8.25 9.75L11.625 6.375M8.99486 3.85186C7.49535 2.0988 4.99481 1.62723 3.11602 3.23251C1.23723 4.83779 0.972726 7.52173 2.44815 9.4203C3.56257 10.8543 6.72847 13.7332 8.21101 15.0562C8.48354 15.2994 8.61981 15.421 8.77937 15.4688C8.9179 15.5104 9.07183 15.5104 9.21036 15.4688C9.36992 15.421 9.50619 15.2994 9.77872 15.0562C11.2613 13.7332 14.4272 10.8543 15.5416 9.4203C17.017 7.52173 16.7848 4.8209 14.8737 3.23251C12.9626 1.64412 10.4944 2.0988 8.99486 3.85186Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>